import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Briefcase, Users, LayoutGrid } from 'lucide-react';

const TABS = [
  { path: '/admin/recruitment/jobs', label: 'Job Openings', icon: Briefcase, testId: 'recruitment-nav-jobs' },
  { path: '/admin/recruitment/candidates', label: 'Candidates', icon: Users, testId: 'recruitment-nav-candidates' },
  { path: '/admin/recruitment/kanban', label: 'Pipeline Board', icon: LayoutGrid, testId: 'recruitment-nav-kanban' }
];

export const RecruitmentNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="inline-flex items-center gap-1 bg-slate-100 rounded-lg p-1" data-testid="recruitment-nav">
      {TABS.map(tab => {
        const active = location.pathname === tab.path;
        const Icon = tab.icon;
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            data-testid={tab.testId}
            className={`flex items-center gap-2 px-3.5 py-1.5 rounded-md text-sm font-medium transition-colors ${
              active
                ? 'bg-white text-slate-900 shadow-sm'
                : 'text-slate-500 hover:text-slate-800'
            }`}
          >
            <Icon className="w-4 h-4" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default RecruitmentNav;
